import { Table } from "react-bootstrap";
import styled from "styled-components";

const TachHistoryTableContainer = styled.div`
    display: flex;
    margin-top: 40px;

    @media only screen and (max-width: 850px) {
        overflow-x: auto !important;
    }
`;

const TachHistoryTable = styled(Table)`
    border-collapse: collapse;
    border-spacing: 0;
    box-sizing: border-box;
    table-layout: fixed;
    border-left: 1px solid #e4e4e4;
    width: 100%;

    th {
        text-align: center;
        vertical-align: middle;
        justify-content: center;
        align-items: center;
        padding: 8px 16px;
        gap: 8px;
        left: 108px;
        top: 337px;
        background: #e4e4e4;
        box-sizing: border-box;
    }

    tr {
        box-sizing: border-box;
    }

    td {
        justify-content: center;
        vertical-align: middle;
        align-items: center;
        background: #ffffff;
        border-width: 0px 1px 1px 1px;
        border-style: solid;
        border-color: #e4e4e4;
        font-size: 15px;
        color: #404040;
        font-weight: 400;
        font-size: 17px;
        line-height: 150%;
        padding-bottom: 18px;
        padding-top: 18px;
        text-align: center;
        border-style: solid;
        box-sizing: border-box;

        &.negative-value {
            color: #e5000c;
        }

        &.positive-value {
            color: #7ee543;
        }
    }
    &.no-border {
        tr,
        th,
        td {
            border: none;
        }
    }
    & > .text-align-right {
        tr,
        th,
        td {
            text-align: right;
        }
    }

    @media only screen and (max-width: 850px) {
        min-width: 600px;
    }
`;

const TachIconButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    margin: 0 16px;

    &:hover {
        opacity: 0.8;
    }
`;

export default {
    TachHistoryTableContainer,
    TachHistoryTable,
    TachIconButton,
};
